import { useRef, useCallback } from "react";

/**
 * Draft filter state (toolbar onChange) vs applied filter (last Search / Reset / modal submit).
 * Prevents filter API calls when the user edits fields before clicking Search.
 */
export function useCallExecutiveAppliedFilter() {
  const appliedFilterRef = useRef({});
  const initialLoadDoneRef = useRef(false);

  const setAppliedFilter = useCallback((nextFilter) => {
    appliedFilterRef.current =
      nextFilter && typeof nextFilter === "object" ? { ...nextFilter } : {};
  }, []);

  const commitDraftAsApplied = useCallback((draftFilter) => {
    setAppliedFilter(draftFilter);
  }, [setAppliedFilter]);

  const getAppliedFilter = useCallback(() => appliedFilterRef.current, []);

  const resolveFilterBase = useCallback((filterOverride) => {
    if (filterOverride !== undefined && filterOverride !== null) {
      setAppliedFilter(filterOverride);
      return filterOverride;
    }
    return appliedFilterRef.current;
  }, [setAppliedFilter]);

  return {
    appliedFilterRef,
    initialLoadDoneRef: initialLoadDoneRef,
    setAppliedFilter,
    commitDraftAsApplied,
    getAppliedFilter,
    resolveFilterBase,
  };
}
